import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
import { BaseUrl } from "../../helper/BaseUrl";

const applicationListEndpoint = ApiEndpoints.application.applicationList;

const tableHeader = ["Date", "first Name", "last name", "email", "phone", "gender", "DOB", "current salary", "expacted salary", "notice period", "location", "exp. in year", "exp. in month", "resume", "Cover letter/Portfolio", "IP Address" ];

const tbody = ["createdAt", "first_name", "last_name", "email", "phone", "gender", "dob", "monthly_current_salary", "monthly_expacted_salary", "notice_period_in_days", "location", "total_work_exp_in_year", "total_work_exp_in_month", "resume", "cover_note", "ip_address" ];

export default function JobApplications() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
    try {
        const response = await ApiRequest("GET", applicationListEndpoint);
        const result = response.jobs.map((item) => ({
        ...item,
        resume: item.resume ? (
            <a href={`${BaseUrl}${item.resume}`} target="_blank" rel="noopener noreferrer" download>
            <img src="/assets/view.webp" alt="view" style={{ width: "20px" }}/></a>
        ) : (
            "No file"
        ),

        cover_note: item.cover_note ? (
            <a href={`${BaseUrl}${item.cover_note}`} target="_blank" rel="noopener noreferrer" download>
            <img src="/assets/view.webp" alt="view" style={{ width: "20px" }}/></a>
        ) : (
            "No file"
        ),
        }));

        setData(result);
    } catch (error) {
        console.log(error);
    }
    };


    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'Job Applications',
      user: 'Admin',
      innerpage: 'Job Applications'
    }

//   const contactUsData = data?.filter((item)=> item.form_type === "partner_form");

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
